exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".CodeMirror {\n\theight: 600px;\n}\n", ""]);

// exports



/*****************
 ** WEBPACK FOOTER
 ** ./~/css-loader!./app/styles.css
 ** module id = 179
 ** module chunks = 0
 **/